<template>
	<el-card>
		<div slot="header">
			<el-button @click="onUserAdd" type="primary">添加管理员</el-button>
		</div>
		<el-table ref="multipleTable" :data="userList" tooltip-effect="dark" style="width: 100%">
			<el-table-column type="selection" width="55"> </el-table-column>
			<el-table-column prop="uid" label="ID" width="50"> </el-table-column>
			<el-table-column prop="username" label="用户名" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="group_name" label="用户组" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="login_ip" label="登录IP" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="last_login_time" :formatter="$f.timeFormat" label="最后登录时间" show-overflow-tooltip>
			</el-table-column>
			<el-table-column prop="create_time" :formatter="$f.timeFormat" label="创建时间" show-overflow-tooltip>
			</el-table-column>
			<el-table-column width="200px;">
				<template slot-scope="scope">
					<el-button @click="onUserEdit(scope.row)">编辑</el-button>
					<el-button type="danger" @click="deleteUser(scope.row.uid,scope.$index)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 添加管理员弹窗 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
			<el-form :model="form" ref="form">
				<el-form-item>
					<el-select v-model="form.group_id" placeholder="请选择用户组">
						<el-option v-for="item in groupList" :key="item.group_id" :label="item.name" :value="item.group_id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="用户名">
					<el-input v-model="form.username" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="密码">
					<el-input v-model="form.password" autocomplete="off"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button v-if="isEdit" type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="saveUserInfo">保存</el-button>
				<el-button v-else type="primary" :loading="btnLoading" :disabled="btnDisabled" @click="addSubmit">确定</el-button>
			</div>
		</el-dialog>
	</el-card>
</template>

<script>
	export default {
		data() {
			return {
				dialogTitle: "添加管理员",
				btnLoading: false,
				btnDisabled: false,
				userList: [],
				dialogFormVisible: false,
				isEdit:false,
				form: {
					group_id: "",
					username: "",
					password: ""
				},
				pwd: "",
				groupList: []
			};
		},
		created() {
			this.handleUserList();
			this.getGroupList();
		},
		methods: {
			saveUserInfo(){
				this.$H.post("user/saveUserInfo", this.form).then(res => {
					if (res.code == 200) {
						this.$message.success("保存成功");
						this.dialogFormVisible = false;
					}
				})
			},
			onUserAdd() {
				this.isEdit = false;
				this.dialogFormVisible = true;
				this.form = {
					group_id: "",
					username: "",
					password: ""
				}
			},
			onUserEdit(userInfo) {
				this.isEdit = true;
				this.dialogFormVisible = true;
				this.dialogTitle = "编辑";
				this.form = userInfo;
				this.form.password = "";
			},
			getGroupList() {
				this.$H.get("user/roleList").then(res => {
					this.groupList = res.result;
					console.log(res.result)
				})
			},
			addSubmit() {
				this.$H.post("user/adminAdd", this.form).then(res => {
					if (res.code == 200) {
						this.$message.success("添加成功");
						this.userList.push(res.result);
						this.dialogFormVisible = false;
					}
				})
			},
			handleUserList() {
				this.$H.get("user/adminList").then((res) => {
					this.userList = res.result;
				});
			},
			deleteUser(uid, index) {
				this.$confirm('此操作将删除该用户, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					//删除用户的接口
					this.$H.post("user/delAdmin", {
						uid: uid
					}).then(res => {
						if (res.code == 200) {
							this.userList.splice(index, 1)
							this.$message.success("删除成功");
						}
					})
				})
			}
		},
	};
</script>

<style>

</style>
